var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProgramAtom2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 198,
    viewBox: "0 0 247 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.0021 163.05L126.203 82.5549L31.5974 60.4436",
    stroke: "#263238",
    strokeWidth: 2.3576,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0242 139.992C96.8311 137.725 109.491 146.219 112.298 158.967C115.105 171.716 106.995 183.886 94.1882 186.153C81.3813 188.419 68.7215 179.926 65.9144 167.177C63.1073 154.429 71.2172 142.259 84.0242 139.992Z",
    fill: "#80FFAF",
    stroke: "#263238"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3901 144.779C99.1819 146.994 104.702 152.682 106.321 160.036L92.3901 144.779Z",
    fill: "#80FFAF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3901 144.779C99.1819 146.994 104.702 152.682 106.321 160.036",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7429 33.5762C43.8604 30.9003 58.8038 40.9264 62.1171 55.9742C65.4305 71.022 55.8579 85.3875 40.7403 88.0634C25.6228 90.7393 10.6794 80.7132 7.36609 65.6655C4.05274 50.6177 13.6253 36.2521 28.7429 33.5762Z",
    fill: "#FFF4D9",
    stroke: "#263238"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0298 39.225C47.0134 41.8395 53.5085 48.5016 55.417 57.1722",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M197.096 19.4076C206.823 17.6861 216.438 24.1365 218.57 33.8191C220.702 43.5018 214.542 52.7444 204.816 54.466C195.09 56.1876 185.475 49.7372 183.343 40.0545C181.211 30.3719 187.37 21.1292 197.096 19.4076Z",
    fill: "#FFF4D9",
    stroke: "#263238"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M202.908 23.0523C208.089 24.7471 212.329 29.0743 213.57 34.7138",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M114.691 51.2357C133.268 47.9475 151.63 60.2679 155.701 78.7582C159.773 97.2484 148.01 114.901 129.433 118.189C110.856 121.478 92.4942 109.157 88.4228 90.6669C84.3515 72.1766 96.114 54.5239 114.691 51.2357Z",
    fill: "#FFF4D9",
    stroke: "#263238"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M127.865 58.1895C137.645 61.3891 145.604 69.5743 147.936 80.1717",
    stroke: "#263238",
    strokeWidth: 1.4476,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgramAtom2);
export default __webpack_public_path__ + "static/media/program-atom-2.dc9de779523782df7cbe023c79040864.svg";
export { ForwardRef as ReactComponent };